import React, { useContext, useMemo, useState } from "react";
import EyeIcon from "../images/eye-switch.svg";
import MainLogo from "../images/login-logo.svg"
import "../scss/login.scss";
import { folderNameRegex } from "../helpers/RegexHelpers";
import { setToSession } from "../helpers/GenericHelpers";
import { faUser, faKey } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { RoutesEnum } from "../models/RoutesModel";
import Service from "../services";
import { ThemeTypes } from "../models/SharedModel";
import { ThemeContext } from "../models/ThemeContext";

const LoginPage = () => {
  // Todo: remove from here
  enum fieldType {
    TEXT = "text",
    PASSWORD = "password",
  }

  interface IInputValuesModel {
    username: string,
    password: string,
  }

  // states
  const [type, setType] = useState(fieldType.PASSWORD);

  const [error, setError] = useState("");
  const [errorField, setErrorField] = useState("");
  const service = new Service();


  const [inputValues, setInputValues] = useState<IInputValuesModel>({
    username: '',
    password: ''
  })

  // helpers
  const toogleType = () =>
    setType((prev) =>
      prev === fieldType.TEXT ? fieldType.PASSWORD : fieldType.TEXT
    );

  const handleChange = (value: string, field: string) => {
    setError('')
    setInputValues(prev => ({ ...prev, [field]: value }))
  } 

  const validateUserName = (value: string) => {
    if (value?.match(folderNameRegex)) {
      setError('')
    } else setError('Only alphabets, 0-9, "_" are allowed for Username')
  }

  const signInDisabled = useMemo(() => {
    if (error) return true
    else return false
  }, [error, inputValues])

  // apis 
  const signInSubmit = () => {
    // check username
    if (inputValues?.username?.length < 5) {
      setError('Username must have minumum 4 characters')
    } 
    // check password
    else if (inputValues?.password?.length < 5) {
      setError('Password must have minumum 4 characters')
    } 
    // check if no errors trigger redirection
    else if (!error) {
      const data = {
        username:inputValues.username,
        // role_name:role,
      }
      service.get_logged_in_user(data).then((response:any)=>{
        if(response?.data === 'Username not found'){
          setError('No user found please sign up !')
        }else{
          setToSession('user_name', response?.data?.logged_in_user_details?.username)
          setToSession('user_id', response?.data?.logged_in_user_details?.user_id)
          window.location.href = '/landing'
        }
      }).catch((error:any)=>{
        setError('No user found please sign up !')
        console.log(error)
      })
    } 
  }

  const goToSignUp = () =>{
    window.location.href = `${RoutesEnum.SIGNUP}`
  }

  const { themeName } = useContext(ThemeContext);

  return (
    <div className={`${themeName === ThemeTypes?.BLUE_THEME ? 'login-main-light' :'login-main-dark'}`}>
      <div className="login-form">
        <div className="main-logo">
          <img src={MainLogo} alt="MainLogo" className="logo-icon" />
          <div className="main-heading">Welcome Back!</div>
          <div className="sub-heading">Please log in. </div>

          <div className="form-main">
            <div className="erorr-message">{error}</div>

            <p className={`input-box username ${errorField === fieldType.TEXT ? 'error' : ''}`}>
              <div className="icon"><FontAwesomeIcon icon={faUser} /></div>
              <input
                type="text"
                id="username"
                name="username"
                className="form-control"
                placeholder="Username"
                required={true}
                value={inputValues?.username || ''}
                onChange={e => {
                  handleChange(e?.target?.value, 'username')
                  validateUserName(e?.target?.value)
                }}
                onBlur={e => validateUserName(e?.target?.value)}
                onKeyDown={e => e.code === "Enter" && signInSubmit()}
              />
            </p>

            <p className={`input-box password ${errorField === fieldType.PASSWORD ? 'error' : ''}`}>
              <div className="icon"><FontAwesomeIcon icon={faKey} /></div>
              <input
                type={type}
                id="password"
                name="password"
                className="form-control"
                placeholder="Password"
                required={true}
                value={inputValues?.password || ''}
                onChange={e => handleChange(e?.target?.value, 'password')}
                onKeyDown={e => e.code === "Enter" && signInSubmit()}
              />
              <img
                src={EyeIcon}
                alt="eyeIcon"
                onClick={toogleType}
                className="show"
              />
            </p>

            <div><Link to={""} onClick={()=>goToSignUp()}>Signup</Link></div>

            <button 
              className="sign-in-button" 
              type="submit"
              disabled={signInDisabled}
              onClick={signInSubmit}
            >
              Log In
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
